<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver al listado de U.I.">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="hasAccessCreateCorte && uiHabilitadaParaCortes" class="btn btn-outline-success" [disabled]="actionNotAllowed" type="button" (click)="onCrearCorte()" title="Añadir corte/autorización (Kgs.)">
            <i class="fa fa-file-o"></i> Añadir corte/autorización (Kgs.)</button>
    </form>
</nav>

<div class="container-fluid container-list">
    <h4 class="pt-3">Cortes/Autorizaciones (Kgs.) de la Unidad de Inspección</h4>

    <ng-container *ngIf="unidadInspeccion?.FirstRecinto">
        <!-- No se muestra ésta cabecera cuando se invoca desde el detalle de una inspección -->
        <app-unidad-inspeccion-header [formGroup]="formGroup" [unidadInspeccion]="unidadInspeccion"></app-unidad-inspeccion-header>
    </ng-container>

    <ng-container *ngIf="hasVerCorteAccess">
        <ng-container *ngIf="cultivosAforosCortes">
            <app-inspeccion-ui-aforo-corte-list 
                [hasDeletingAccess]="hasDeleteCorteAccess" [hasViewAccess]="hasVerCorteAccess"
                [readonly]="actionNotAllowed" [cultivosAforosCortes]="cultivosAforosCortes" [title]="title" (delete)="onDelete($event)" (view)="onView($event)">
            </app-inspeccion-ui-aforo-corte-list>
        </ng-container>
        <ng-container *ngIf="!cultivosAforosCortes && uiHabilitadaParaCortes">
            <div class="nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Información relativa a cortes no disponible.</label>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!hasVerCorteAccess && !unidadInspeccion?.PeriodoCertificaKgs">
        <div class="nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no habilitado para Certificar Kgs.</label>
        </div>        
    </ng-container>
    <ng-container *ngIf="!hasVerCorteAccess && unidadInspeccion?.PeriodoCertificaKgs">
        <div class="nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Información relativa a cortes no disponible.</label>
        </div>        
    </ng-container>    
</div>